<template>
  <div class="edit-employe">
    <el-backtop target=".edit-employe"></el-backtop>
    <header-top showBack haveTab></header-top>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="基本信息">
        <basic-info v-if="activeName == '基本信息'" ref="info"></basic-info>
      </el-tab-pane>
      <el-tab-pane
        v-if="permissions['Company.LookEventRecords']"
        label="大事记"
        name="大事记"
      >
        <growth v-if="activeName == '大事记'"></growth>
      </el-tab-pane>
      <el-tab-pane
        v-if="permissions['Company.LookMaterials']"
        label="资料附件"
        name="资料附件"
      >
        <material-accessories
          v-if="activeName == '资料附件'"
        ></material-accessories>
      </el-tab-pane>
      <el-tab-pane
        label="操作日志"
        name="操作日志"
        v-if="
          permissions['AuditLogging.ViewChangeHistory:Deer.Companies.Company']
        "
      >
        <operation-record v-if="activeName == '操作日志'"></operation-record>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
var tabName = "";

import headerTop from "@/components/HeaderTop";
import basicInfo from "./basicInfo.vue";
import operationRecord from "./operation-record.vue";
import growth from "./growth.vue";
import materialAccessories from "./material-accessories.vue";

export default {
  components: {
    headerTop,
    basicInfo,
    operationRecord,
    growth,
    materialAccessories,
  },
  data() {
    return {
      headerText: "分销商管理",
      activeName: "基本信息",
      permissions: this.$store.getters.permissions,
    };
  },
  created() {
    if (tabName) {
      this.activeName = tabName;
    }
  },
  methods: {
    handleClick(tab, event) {
      tabName = this.activeName;
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.edit-employe {
  overflow-y: auto;

  ::v-deep .el-tabs {
    .el-tabs__header {
      padding-left: 15px;
    }
    .el-tabs__content {
      padding: 20px;
    }
  }
}
</style>